
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.27 12.558a4.886 4.886 0 001.317-5.404 4.906 4.906 0 00-1.807-2.29 4.934 4.934 0 00-5.582 0 4.906 4.906 0 00-1.806 2.29 4.886 4.886 0 001.316 5.404A7.03 7.03 0 005.3 15.113 6.989 6.989 0 004 19.16a.838.838 0 00.842.839.844.844 0 00.842-.839 5.324 5.324 0 011.568-3.766 5.363 5.363 0 013.78-1.562h1.936a5.363 5.363 0 013.78 1.562 5.324 5.324 0 011.568 3.766.838.838 0 00.842.839.844.844 0 00.842-.839 6.99 6.99 0 00-1.308-4.053 7.03 7.03 0 00-3.422-2.55zM11.99 5.72a3.211 3.211 0 012.976 1.98 3.2 3.2 0 01-.7 3.498 3.225 3.225 0 01-3.51.695 3.219 3.219 0 01-1.445-1.182 3.2 3.2 0 01.4-4.052 3.227 3.227 0 012.278-.94z","fill":"currentColor"}})])
          )
        }
      }
    